module.exports = __webpack_public_path__ + "img/firework.80f74d65.png";